import {TranslateLoader, TranslationObject} from '@ngx-translate/core';
import {from, Observable} from 'rxjs';

export function syncTranslateLoaderFactory(): TranslateLoader {
  return new SyncTranslateLoaderService();
}

export class SyncTranslateLoaderService implements TranslateLoader {
  /**
   * Instantly get the translations instead of using an HTTP request,
   * which proved to be more volatile since it's async
   * @param lang
   */
  public getTranslation(lang: string): Observable<TranslationObject> {
    return from(import(`../../../assets/i18n/${lang}.json`));
  }
}
